<template>
  <div id="review-list">
    <div v-if="!selectReviewListLoading">
      <div v-if="selectReviews.length">
        <!-- For larger screens (md and up) - two column layout -->
        <div class="row d-none d-md-flex">
          <!-- Left column -->
          <div class="col-md-6">
            <div
              class="card p-4 mb-3 reviewList"
              v-for="review in leftColumnReviews"
              :key="review._id + '-md'"
            >
              <ReviewCard :review="review" />
            </div>
          </div>

          <!-- Right column -->
          <div class="col-md-6">
            <div
              class="card p-4 mb-3 reviewList"
              v-for="review in rightColumnReviews"
              :key="review._id + '-md'"
            >
              <ReviewCard :review="review" />
            </div>
          </div>
        </div>

        <!-- For smaller screens (below md) - single column layout -->
        <div class="d-md-none">
          <div
            class="card p-4 mb-3 reviewList"
            v-for="review in selectReviews"
            :key="review._id + '-sm'"
          >
            <ReviewCard :review="review" />
          </div>
        </div>

        <!-- pagination states -->
        <div v-if="fetchMorePending" class="d-flex justify-content-center align-items-center my-3">
          <b-spinner small variant="primary" />
        </div>
        <div
          v-if="selectAllReviewsLoaded"
          class="d-flex justify-content-center align-items-center my-3"
        >
          No more reviews
        </div>
      </div>

      <!-- empty state -->
      <div v-else>- No reviews matching given filters</div>
    </div>

    <!-- loader -->
    <div v-else>
      <!-- For larger screens (md and up) - two column loader -->
      <div class="row d-none d-md-flex">
        <div class="col-md-6">
          <div class="card p-4 mb-3" v-for="x in 4" :key="'skeleton-left-' + x">
            <b-skeleton height="200px" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="card p-4 mb-3" v-for="x in 4" :key="'skeleton-right-' + x">
            <b-skeleton height="200px" />
          </div>
        </div>
      </div>

      <!-- For smaller screens (below md) - single column loader -->
      <div class="d-md-none">
        <div class="card p-4 mb-3" v-for="x in 8" :key="'skeleton-sm-' + x">
          <b-skeleton height="200px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewCard from './ReviewCard.vue'
import { createNamespacedHelpers } from 'vuex'

const ReviewModule = createNamespacedHelpers('review')

export default {
  name: 'ReviewList',
  components: {
    ReviewCard
  },
  props: {
    fetchMorePending: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    intersectionObserver: null
  }),
  async mounted() {
    await this.fetchReviewList()
  },
  computed: {
    ...ReviewModule.mapGetters([
      'selectReviews',
      'selectReviewListLoading',
      'selectAllReviewsLoaded'
    ]),
    leftColumnReviews() {
      return this.selectReviews.filter((_, index) => index % 2 === 0)
    },
    rightColumnReviews() {
      return this.selectReviews.filter((_, index) => index % 2 === 1)
    }
  },
  methods: {
    ...ReviewModule.mapActions(['fetchReviewList'])
  }
}
</script>

<style lang="scss" scoped>
.virtual {
  position: absolute;
  height: 200px;
  top: -200px;
  width: 100%;
}
.reviewList {
  width: 100%;
}
</style>
